.menuIcon,
.dismissIcon,
.chevronIcon {
  path {
    /* stylelint-disable-next-line declaration-no-important */
    fill: var(--bloom-colors-header-contrast) !important;
  }
}

.chevronContainer {
  width: 72px;
  height: 48px;
  justify-content: right;
  margin-left: auto;
  align-items: center;
}

.dismissIconContainer {
  margin-top: 12px;
}

.mainMenuModal {
  position: absolute;
  background-color: var(--bloom-colors-header-main);
  /* stylelint-disable-next-line declaration-no-important */
  transition: left 0.5s !important;
  /* stylelint-disable-next-line declaration-no-important */
  --modal-transform: translate(0, -50%) !important;

  left: 100%;
  width: 100%;
}

.mainMenuFooter {
  display: block;
  box-shadow: none;
}

.closeButton {
  background-color: var(--bloom-colors-header-contrast);
  border-color: var(--bloom-colors-header-contrast);
  color: var(--bloom-colors-header-contrast-text-label);
}

.mainMenuItemShared {
  color: var(--bloom-colors-header-contrast);
  text-decoration: none;
  width: 100%;
}

.mainMenuItem {
  display: flex;
  height: 48px;
  padding-left: 8px;
  align-items: center;
}

.mainMenuSubItem {
  padding: 12px 24px;
}

.mainMenuTertiaryItem {
  padding: 12px 48px;
}

.parentLinkContainer {
  display: flex;
  justify-content: space-between;
  padding-left: 16px;
  padding-right: 20px;
}

.logoContainer {
  display: block;
}

.mainMenuHeader {
  justify-content: space-between;
  padding: 16px 20px 0 16px;
}

.parentLinkContainer:hover,
.dismissIconContainer:hover,
.mainMenuSubItem:hover {
  background-color: var(--bloom-colors-header-highlight);
}

@media all and (--reefer-media-tablet-min) {
  .dismissIconContainer {
    margin-top: 0px;
    justify-content: right;
  }

  .mainMenuModal {
    width: 306px;
  }

  .logoContainer {
    display: none;
  }

  .mainMenuFooter {
    display: none;
  }

  .mainMenuHeader {
    justify-content: right;
  }
}
